import { UsageLimit } from 'modules/domains/billing';
import { createContext, useContext } from 'react';

type UsageLimitsContextState = {
  isBillingLimitsEnabled: boolean;
  isLoading: boolean;
  metricUsageLimit: Record<string, UsageLimit[]>;
};

export const UsageLimitsContext = createContext<UsageLimitsContextState | undefined>(undefined);

export const useUsageLimitsContext = () => {
  const context = useContext<UsageLimitsContextState | undefined>(UsageLimitsContext);
  if (context === undefined) {
    throw new Error('useUsageLimitsContext must be used within a UsageLimitsContextProvider');
  }
  return context;
};
